import React from "react";
import { Typography, Row, Col } from "antd";
import { ICD11Intro } from "../../Util/writing";
import useWindowResize from "../../Util/screenSize";

const { Title } = Typography;

const Introduction = () => {
  const width = useWindowResize()[0];

  const getStyles = () => {
    if (width > 700) {
      return {
        titleLevel: 3,
        bodyMarginLeft: 35,
        bodyMarginRight: 35,
        bodyMarginTop: 30,
        teamHeadingAlign: "right",
        teamHeadingMarginRight: 380,
        teamWidth: 380,
      };
    }
    return {
      titleLevel: 4,
      bodyMarginLeft: 25,
      bodyMarginRight: 25,
      bodyMarginTop: 10,
      teamHeadingAlign: "center",
      teamHeadingMarginRight: null,
      teamWidth: null,
    };
  };

  const styles = getStyles();

  return (
    <React.Fragment>
      <Row>
        {/* CHI Logo */}
        <Col xs={12} sm={12} md={6} lg={6} xl={5}>
          <img src="../../../CHI_logo.png" alt="CHI Logo" style={{ width: "100%", paddingLeft: 10 }} />
        </Col>

        {/* Title on large screens */}
        <Col xs={0} sm={0} md={13} lg={13} xl={15}>
          <Typography style={{ padding: 20 }}>
            <Title level={styles.titleLevel} style={{ textAlign: "center" }}>
              ICD-11 Cost Benefit Calculator
            </Title>
          </Typography>
        </Col>

        {/* Empty column for spacing on small screen */}
        <Col xs={2} sm={2} md={0} lg={0} xl={0} />

        {/* WHO Logo */}
        <Col xs={10} sm={10} md={5} lg={5} xl={4}>
          <img src="../../../WHOlogo.png" alt="WHO Logo" style={{ width: "100%", paddingRight: 10 }} />
        </Col>

        {/* Title on small screens */}
        <Col xs={24} sm={24} md={0} lg={0} xl={0}>
          <Typography style={{ paddingTop: 20 }}>
            <Title level={styles.titleLevel} style={{ textAlign: "center" }}>
              ICD-11 Cost Benefit Calculator
            </Title>
          </Typography>
        </Col>
      </Row>

      <Typography
        style={{
          padding: 0,
          marginLeft: styles.bodyMarginLeft,
          marginRight: styles.bodyMarginRight,
          marginTop: styles.bodyMarginTop,
        }}
      >
        {ICD11Intro}
      </Typography>

      <div style={{ float: "right", padding: 40, paddingRight: 10, paddingLeft: 10 }}>
        <Title level={5} style={{ textAlign: styles.teamHeadingAlign, marginRight: styles.teamHeadingMarginRight }}>
          Team Members:
        </Title>
        <Typography style={{ lineHeight: "1em", textAlign: "left", fontSize: "0.8em", width: styles.teamWidth }}>
          Shahreen Khair, Chelsea Doktorchik, Cathy A Eastwood, Hude Quan, Danielle A Southern, Oscar Chen, Alexander
          Krusina, Nikolai Albricht, Zahra Shakeri, Mingshan Lu.
        </Typography>
        <Typography
          style={{
            lineHeight: "1em",
            textAlign: "left",
            fontSize: "0.8em",
            width: styles.teamWidth,
            fontWeight: "bold",
          }}
        >
          Get in touch with us: chi@ucalgary.ca
        </Typography>
      </div>
    </React.Fragment>
  );
};

export default Introduction;
